import { track } from '@/common/monitoring/heap';

const baseHeapData: Record<string, any> = {
  eventType: 'EmailVerifyForm',
  eventLabel: 'FindTicketsEmailVerifyForm',
};

const trackEvent = (eventName: string, eventAction: string) => {
  track({
    eventName,
    eventData: { ...baseHeapData, eventAction },
  });
};

export const trackEmailValidationFailure = () => {
  trackEvent('EmailVerifyFormValidationFailure', 'EmailValidationFailure');
};

export const trackAccountFound = () => {
  trackEvent('EmailVerifyFormAccountFound', 'AccountFound');
};

export const trackNoAccountFound = () => {
  trackEvent('EmailVerifyFormNoAccountFound', 'NoAccountFound');
};

export const trackAPIError = () => {
  trackEvent('EmailVerifyFormAPIError', 'APIError');
};

export const trackFormSubmission = () => {
  trackEvent('EmailVerifyFormSubmission', 'EmailVerifyFormSuccess');
};
